import React from "react";
import { connect } from "react-redux";
import { Field } from "formik";
import FormContainer from "forms/components/FormContainer";
import FormRow from "forms/components/FormRow";
import { MultiDropdownField } from "forms/fields";
import PropTypes from "prop-types";
import Information from "rialto-icons/Information";
import { isAssetDetail } from "selectors/location";

import DropdownTag from "components/Dropdown/DropdownTag";
import { Translate } from "utils";

import styles from "forms/forms.css";

const { t } = new Translate("DealForm");

const Assets = ({ assets, formik: { values }, isAssetDetailPage }) => {
  const asset = isAssetDetailPage ? values.assets[0] : null;

  return (
    <FormContainer title={t("assets.title", asset ? 1 : 2)}>
      <FormRow columns={1}>
        {asset ? (
          <DropdownTag content={asset.name} />
        ) : (
          <>
            <Field
              component={MultiDropdownField}
              name="assets"
              placeholder={t("placeholders.assets")}
              valueExtractor={(v) => v.name}
              values={assets}
            />
            <div className={styles.info}>
              <Information />
              {t("assets.info")}
            </div>
          </>
        )}
      </FormRow>
    </FormContainer>
  );
};

Assets.propTypes = {
  assets: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
  isAssetDetailPage: PropTypes.bool,
  formik: PropTypes.shape({
    values: PropTypes.shape({
      assets: PropTypes.array,
    }),
  }),
};

const mapStateToProps = (state) => ({
  assets: state.assetNames,
  isAssetDetailPage: isAssetDetail(state),
});

export default connect(mapStateToProps)(Assets);
